import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles/Pagination.module.scss';

type PaginationProps = {
  newsAmount: number;
  page: number;
  setPage: (value: React.SetStateAction<number>) => void;
  pageCount: number;
  perPage: number;
};

const Pagination: React.FunctionComponent<PaginationProps> = (props: PaginationProps) => {
  const { t } = useTranslation();
  const { newsAmount, page, setPage, pageCount, perPage } = props;

  const prevDisabled = page <= 1;
  const nextDisabled = page > newsAmount / perPage;
  const pageButtons = [];

  for (let i = 1; i <= pageCount; i++) {
    pageButtons.push(
      <button key={i} className={page === i ? styles.active : ''} onClick={(): void => setPage(i)}>
        {i}
      </button>,
    );
  }

  return (
    <div className={styles.pagination}>
      <button
        className={`${styles.prev} ${prevDisabled ? styles.disabled : ''}`}
        onClick={(): void => (prevDisabled ? setPage(page) : setPage(page - 1))}
        aria-label={`${t('news:pagination.prev')}`}
      />
      {pageButtons}
      <button
        className={`${styles.next} ${nextDisabled ? styles.disabled : ''}`}
        onClick={(): void => (nextDisabled ? setPage(page) : setPage(page + 1))}
        aria-label={`${t('news:pagination.next')}`}
      />
    </div>
  );
};

export default Pagination;
